import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { getAppendix } from '@/core';
import palette from '@/theme/palette';

export const TotalItemsLabel = ({ count }: { count: number }) => {
  const { t } = useTranslation();
  return (
    <Typography variant="body2" sx={{ color: palette.text.primary, fontWeight: 600 }}>
      {getAppendix({ count, translator: t })}
    </Typography>
  );
};
